// @flow

import ClearInput from './ClearInput';
import Notifications from '../constants/Notifications';

export default class SearchClear extends ClearInput {
  /**
   * @inheritDoc
   */
  onClick(): void {
    super.onClick();
    this.notify(Notifications.CLEARED_SEARCH_KEYWORD);
  }
}
